export enum ModeOfOperation {
    STORE_LEARNING = "STORE_LEARNING",
    AGENT_TRAINING = "AGENT_TRAINING",
    AI = "AI",
    AGENT_AI_TRAINING = "AGENT_AI_TRAINING",
    SUPER_AI = "SUPER_AI"
}
